module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-5-m1.c10084b4.jpg";